import { useNotify } from "@/hooks/useNotify";
import { Button, Group, Image, Modal, Space, Text, rem } from "@mantine/core";
import ringNotification from "assets/images/pngs/imagethongbao.png";
import { useTranslation } from "react-i18next";

const NotificationPopup = () => {
  const { t } = useTranslation();
  const { show, hide, current } = useNotify();

  return (
    <Modal opened={current.visible} onClose={hide} centered closeOnClickOutside>
      <Group
        position="center"
        sx={{ display: "flex", flexDirection: "column" }}
      >
        <Image
          width={80}
          fit="contain"
          src={ringNotification}
          withPlaceholder
          alt="ad"
          key="ringNotification"
        />
        <Text align="center" fw={700} fz="xl">
          {current.title}
        </Text>
        <Text align="center" fz="md" w="90%" c="dimmed">
          {current.message}
        </Text>
        <Space h={rem(5)} />
        <Group position="center">
          <Button color="primary" onClick={hide} style={{ minWidth: rem(150) }}>
            {t("UNDERSTAND")}
          </Button>
        </Group>

        <Space h={rem(5)} />
      </Group>
    </Modal>
  );
};

export default NotificationPopup;
